import { Buildings, WarningCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useTenantApartments } from "@/api/tenant/queries";
import { ApartmentCard } from "@/components/tenant/apartment-card";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function MyApartmentsPage() {
	const { t } = useTranslation();
	const { data, isLoading, isError, refetch } = useTenantApartments();

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto p-4 lg:p-6">
			<header className="flex flex-col gap-1">
				<div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
					<Buildings weight="duotone" className="size-4 text-primary" />
					<span>{t("roles.endUser")}</span>
				</div>
				<h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">
					{t("tenant.list.title")}
				</h1>
				<p className="max-w-prose text-sm text-muted-foreground">
					{t("tenant.list.subtitle")}
				</p>
			</header>

			{isLoading && (
				<div className="flex flex-col gap-3">
					{Array.from({ length: 3 }).map((_, i) => (
						<Skeleton key={i} className="h-28 w-full rounded-xl" />
					))}
				</div>
			)}

			{isError && (
				<Card className="flex flex-col items-start gap-3 border-destructive/30 bg-destructive/5 p-6">
					<div className="flex items-center gap-2 text-destructive">
						<WarningCircle weight="fill" className="size-5" />
						<p className="font-medium">{t("tenant.list.errorTitle")}</p>
					</div>
					<Button variant="outline" onClick={() => refetch()}>
						{t("tenant.list.errorRetry")}
					</Button>
				</Card>
			)}

			{data && data.length === 0 && (
				<Card className="flex flex-col items-center gap-3 border-dashed bg-muted/30 px-6 py-12 text-center">
					<div className="flex size-12 items-center justify-center rounded-full bg-muted">
						<Buildings
							weight="duotone"
							className="size-6 text-muted-foreground"
						/>
					</div>
					<p className="text-sm text-muted-foreground">
						{t("tenant.list.empty")}
					</p>
				</Card>
			)}

			{data && data.length > 0 && (
				<div className="flex flex-col gap-3">
					{data.map((apartment) => (
						<ApartmentCard key={apartment.id} apartment={apartment} />
					))}
				</div>
			)}
		</div>
	);
}
